export enum LiveReportLabels {
    STemp="Spa Temp.",
    TSP="Set Point",
    HTemp="Heater Temp.",
    SBConnected="Spa Boy Connected",
    Filter="Filter State",
    P1="Pump1",
    H1="Heating State",
    Current="Current",
    Econ='Economy Mode',
    sbVin="Input Voltage",
    sbVout="Electrode Voltage",
    sbI1="Electrode1 Current",
    sbI2="Electrode2 Current",
    sbpH="pH",
    sbORP="ORP",
    sbE1p="Electrode1-P",
    sbE1n="Electrode1-N",
    sbE2p="Electrode2-P",
    sbE2n="Electrode2-N",
    sbStat="Spa Boy Status",
    sbSM="Spa Boy Smart Mode",
    sbProducing="Spa Boy Producing",
    phSM="Smart pH State"
}

// The classic Spa Boy table's names for the V1 electrode codes (SpaBoyLiveRecord).
export const V1ElectrodeState: { [code: number]: string } = {
    0: 'Charge Start',
    1: 'Charge SoftStart',
    2: 'Charge CV',
    3: 'Charge CC',
    4: 'Charge Disconnect',
    5: 'Ramp Down',
    6: 'Flip Polarity',
    7: 'Sample Impedance',
    8: 'PH ORP Measurement',
};

export const V1ElectrodePolarity: { [code: number]: string } = {
    0: 'An',
    1: 'Ap',
    2: 'Bn',
    3: 'Bp',
    4: 'AnBn',
    5: 'AnBp',
    6: 'ApBn',
    7: 'ApBp',
};

export enum PumpState {
    'Off'=0,
    'Low'=15,
    'High'=100,
}

export enum SBConState {
    'Disconnected'=0,
    'Connected'=1,
}

// Filter state labels come from the one shared table, under the name the
// report components already import.
export { filterStateLabels as filterStateMapper } from '../../mqttData/live/filterState';